import produce from "immer"
import { ASC, IDLE } from "const"
import {
    RrsTemplate,
    RrsTemplateLabel,
    RrsTemplateLevel,
    RrsTemplateRiskRank,
} from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initRrsTemplate: RrsTemplate = {
    id: null,
    accountId: null,
    projectId: null,
    name: "",
    default: false,
    locked: false,
    singleRiskMap: true,
    riskMapGenerated: false,
}

export const initRrsTemplateLabel: RrsTemplateLabel = {
    id: null,
    templateId: null,
    categoryId: null,
    name: "",
    shortName: "",
    description: "",
    order: 0,
}

export const initRrsTemplateLevel: RrsTemplateLevel = {
    id: null,
    labelId: null,
    categoryId: null,
    name: "",
    shortName: "",
    description: "",
    order: 0,
}

export const initRrsTemplateRiskRank: RrsTemplateRiskRank = {
    textId: null,
    templateId: null,
    name: "New Rank",
    shortName: "New Rank",
    color: null,
}

const initRrsTemplateState: types.RrsTemplateState = {
    baseRoute: null,

    templateList: {},
    templateIds: [],
    templateEdit: initRrsTemplate,

    labelList: [],
    labelCategoryList: {},
    levelList: {},
    riskRankList: {},

    categories: {
        categoryList: {},
        categoryIds: [],
        categoryChildParent: {},
        filters: {},
        selected: [],
    },

    editLoadState: IDLE,

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadEdit: true,
}

const rrsTemplateReducer = produce((
    draft: types.RrsTemplateState = initRrsTemplateState,
    action: ActionTypes = null,
): types.RrsTemplateState => {
    switch (action.type) {
        case types.RRS_TEMPLATE_BASE_ROUTE:
            draft.baseRoute = action.baseRoute
            return draft

        case types.RRS_TEMPLATE_LIST:
            draft.templateList = action.templateList
            return draft

        case types.RRS_TEMPLATE_IDS:
            draft.templateIds = action.templateIds
            return draft

        case types.RRS_TEMPLATE_EDIT:
            draft.templateEdit = action.template
            return draft

        case types.RRS_TEMPLATE_LABEL_LIST:
            draft.labelList = action.labelList
            return draft

        case types.RRS_TEMPLATE_LABEL_CATEGORY_LIST:
            draft.labelCategoryList = {
                ...draft.labelCategoryList,
                [action.labelId]: action.nestedCategories,
            }
            return draft

        case types.RRS_TEMPLATE_LEVEL_LIST:
            draft.levelList = {
                ...draft.levelList,
                [action.labelId]: action.levelList,
            }
            return draft

        case types.RRS_TEMPLATE_LEVEL_LIST_BY_CATEGORY:
            draft.levelList = {
                ...draft.levelList,
                [action.labelId]: {
                    ...draft.levelList[action.labelId],
                    [action.categoryId]: {
                        levelIds: action.levelIds,
                        levelList: action.levelList,
                    },
                },
            }
            return draft

        case types.RRS_TEMPLATE_RISK_RANK_LIST:
            draft.riskRankList = action.riskRankList
            return draft


        case types.RRS_TEMPLATE_CATEGORIES_CATEGORY_LIST:
            draft.categories.categoryList = action.categoryList
            return draft

        case types.RRS_TEMPLATE_CATEGORIES_CATEGORY_IDS:
            draft.categories.categoryIds = action.categoryIds
            return draft

        case types.RRS_TEMPLATE_CATEGORIES_CATEGORY_CHILD_PARENT:
            draft.categories.categoryChildParent = action.childParent
            return draft

        case types.RRS_TEMPLATE_CATEGORIES_FILTERS:
            draft.categories.filters = action.filters
            return draft

        case types.RRS_TEMPLATE_CATEGORIES_SELECTED:
            draft.categories.selected = action.selected
            return draft


        case types.RRS_TEMPLATE_EDIT_LOAD_STATE:
            draft.editLoadState = action.loadState
            return draft

        case types.RRS_TEMPLATE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.RRS_TEMPLATE_FILTERS:
            draft.filters = action.filters
            return draft

        case types.RRS_TEMPLATE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.RRS_TEMPLATE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default rrsTemplateReducer
